import { useState } from 'react';

import { CustomIconButton } from 'components/buttons';
import CheckModal from 'components/modals/config/CheckModal';

function EditHostCheckButton({ hostname }) {

  const [open, setOpen] = useState(false);

  return (
    <>
      <CustomIconButton type="edit" onClick={() => setOpen(true)} title="Edit" />
      <CheckModal type="host" edit={hostname} open={open} setOpen={setOpen} />
    </>
  );
}

export default EditHostCheckButton;